import { Check, CircleCheckBig } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const CheckIcon = DeckardIconWrapper({ Icon: Check, CircleIcon: CircleCheckBig });
